import styled from 'styled-components';

const Td = styled.td`
  text-align: center !important;
  width: 100%;
`;
export { Td };